import { Budget } from './types'
import { TravelTypeEnum } from '../../../lib/graphql'

export const budgetMap = new Map<TravelTypeEnum, Budget>([
  [
    TravelTypeEnum.NIGHTLY_TRIP,
    {
      Economy: { budgetMin: 120, budgetMax: 250, isPopular: false },
      Standard: { budgetMin: 250, budgetMax: 400, isPopular: true },
      Premium: { budgetMin: 400, budgetMax: 500, isPopular: false },
    },
  ],
  [
    TravelTypeEnum.DAILY_TRIP,
    {
      Economy: { budgetMin: 75, budgetMax: 100, isPopular: false },
      Standard: { budgetMin: 100, budgetMax: 150, isPopular: true },
      Premium: { budgetMin: 150, budgetMax: 250, isPopular: false },
    },
  ],
  [
    TravelTypeEnum.CORPORATE_EVENING_EVENT,
    {
      Economy: { budgetMin: 75, budgetMax: 100, isPopular: false },
      Standard: { budgetMin: 100, budgetMax: 150, isPopular: true },
      Premium: { budgetMin: 150, budgetMax: 250, isPopular: false },
    },
  ],
])
